import { makeAutoObservable } from 'mobx';
import { UserInfo } from '@microsoft/teamsfx';

import { RootStore } from './RootStore';

export default class TeamsUserStore {
  rootStore: RootStore;
  user: UserInfo | null = null;

  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  setUser = (user: UserInfo): void => {
    this.user = user;
  };
}
